/** Dark-themed sx for all LogiFy TextField / Select inputs */
export const logifyInputSx = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#1e1b35",
    borderRadius: "4px",
    fontSize: "0.8rem",
    "& fieldset": { borderColor: "rgba(255,255,255,0.12)" },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.25)" },
    "&.Mui-focused fieldset": { borderColor: "#9678c8" },
  },
  "& .MuiInputLabel-root": { fontSize: "0.75rem", color: "#7a7690" },
  "& .MuiSelect-icon": { color: "#7a7690" },
};

/** Dark-themed styles for MUI DatePicker inputs — LogiFy purple palette */
export const datePickerSx = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#1e1b35",
    borderRadius: "4px",
    fontSize: "0.8rem",
    "& fieldset": { borderColor: "rgba(255,255,255,0.12)" },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.25)" },
    "&.Mui-focused fieldset": { borderColor: "#9678c8" },
  },
  "& .MuiInputLabel-root": { fontSize: "0.75rem", color: "#7a7690" },
  "& .MuiInputAdornment-root .MuiIconButton-root": { color: "#7a7690" },
};

/** Dark-themed popper slots for MUI DatePicker calendar popup */
export const datePickerPopperSlots = {
  desktopPaper: {
    sx: {
      backgroundColor: "#1e1b35",
      backgroundImage: "none",
      border: "1px solid rgba(255,255,255,0.12)",
      borderRadius: "10px",
      boxShadow: "0 12px 40px rgba(0,0,0,0.5)",
      overflow: "hidden",
      "& .MuiPickersLayout-contentWrapper": {
        backgroundColor: "#1e1b35",
      },
      "& .MuiDayCalendar-weekDayLabel": {
        color: "#7a7690",
        fontSize: "0.72rem",
      },
      "& .MuiPickersDay-root": {
        color: "#b0aac8",
        fontSize: "0.8rem",
        "&:hover": { backgroundColor: "rgba(150,120,200,0.15)" },
        "&.Mui-selected": {
          backgroundColor: "#9678c8",
          color: "#fff",
          "&:hover": { backgroundColor: "#8568b8" },
        },
        "&.MuiPickersDay-today": {
          border: "1px solid rgba(150,120,200,0.5)",
        },
        "&.Mui-disabled": {
          color: "#3a3555",
        },
      },
      "& .MuiPickersCalendarHeader-label": {
        color: "#e0ddf0",
        fontSize: "0.85rem",
        fontWeight: 600,
      },
      "& .MuiPickersArrowSwitcher-button": {
        color: "#7a7690",
        "&:hover": { color: "#e0ddf0" },
      },
      "& .MuiPickersYear-yearButton": {
        color: "#b0aac8",
        "&:hover": { backgroundColor: "rgba(150,120,200,0.15)" },
        "&.Mui-selected": {
          backgroundColor: "#9678c8",
          color: "#fff",
        },
      },
    },
  },
  actionBar: {
    sx: {
      borderTop: "1px solid rgba(255,255,255,0.06)",
      backgroundColor: "#1e1b35",
      py: 0.5,
      "& .MuiButton-root": {
        color: "#9678c8",
        fontSize: "0.72rem",
        fontWeight: 600,
        textTransform: "none",
        borderRadius: "6px",
        "&:hover": {
          backgroundColor: "rgba(150,120,200,0.12)",
        },
      },
    },
  },
};
